<template>
    <div class="h-[100px] flex flex-col items-center justify-center rounded-lg border-main-0 border-[1px]
        lg:w-[630px] lg:h-[120px] lg:rounded-2xl">
        <p class="font-semibold text-content-size text-main-1">{{ title }}</p>
        <p class="text-small-size-1 mx-4 font-medium text-center lg:text-small-size lg:mx-0 lg:font-normal lg:text-left mt-3 text-gray_1" v-html="description"></p>
    </div>
</template>
<script>
export default {
    props: ['title', 'description'],
    data() {
        return {

        }
    }
}
</script>
